export default "__VITE_ASSET__CyKawkDK__"